import React from 'react';

import styled from 'styled-components';

import { NwCard } from '@components/Gui/NwCard/NwCard';
import ObjectTagPicker from '@components/TagPicker/ObjectTagPicker';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const StyledCard = styled(NwCard)`
    width: 100%;
`;

/**
 * Card "Tags" per Playlist e Document. La cornice e' qui, tutto il resto lo fa ObjectTagPicker:
 * striscia dei tag applicati, pannello di selezione, creazione al volo.
 *
 * La striscia mostra tutti i tag andando a capo: nella card lo spazio verticale c'e', quindi
 * non ha senso troncare con la pill "+N" come si fa negli header densi.
 */
const ObjectTagsCard = ({ objectTags, onAddTag, onRemoveTag, objectType, vertical }) => (
    <StyledCard title="Tags" icon={byPrefixAndName.fasl['tag']} horizontal={!vertical}>
        <ObjectTagPicker
            itemType={objectType}
            tags={objectTags || []}
            onAddTag={onAddTag}
            onRemoveTag={onRemoveTag}
            stripMaxWidth="100%"
            stripShowAll
        />
    </StyledCard>
);

export default ObjectTagsCard;
